 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"dashboard~extra":"dashboard~extra","dashboard":"dashboard","extra":"extra","pages":"pages"}[chunkId]||chunkId) + "." + {"chunk-01c32d3a":"c717f4f5","chunk-02c298e0":"67ee26b4","chunk-2d0cf2f8":"1605c5a4","chunk-7c3af428":"814d4d38","chunk-074694fa":"d3ef0ec4","chunk-07721f3e":"f16e2e54","chunk-0aa2bc0f":"d9134eb2","chunk-0d748c85":"71762a41","chunk-0d7b152c":"6787d8a1","chunk-1633b25b":"72296e09","chunk-18946130":"c946fa4a","chunk-19fa1fd5":"be09965c","chunk-0bcfae88":"4e1add22","chunk-5fec1e49":"876133e3","chunk-1e9224e1":"d5de2a24","chunk-1f16a04c":"b3f2dd07","chunk-22cf64ce":"eeae13c2","chunk-443d0ed2":"e3fc2bb3","chunk-5789363a":"d9929d04","chunk-00e4166c":"0beca2be","chunk-11262fda":"6a2274f7","chunk-30e9c8ae":"f5f7578e","chunk-51c84beb":"0425bac2","chunk-ffa08bd2":"5634ef41","chunk-452384d8":"49f83d33","chunk-75bb9704":"0a5e1889","chunk-750d0c9e":"f440ed28","chunk-285b0c14":"aa926ce1","chunk-294b265d":"dc25fd34","chunk-2d0b919a":"d5a4ca2d","chunk-2d0bced2":"91594b56","chunk-2d0c9517":"e5db8abc","chunk-2d0ceb8d":"3ff21846","chunk-2d0d6bb3":"23a5ca3e","chunk-2d21af19":"af8c7847","chunk-2d21e1a8":"81c84736","chunk-2d225216":"0b7b4100","chunk-317182db":"84f9605f","chunk-34dd60f0":"b2734711","chunk-35f88b45":"ea82da03","chunk-3a383e43":"bfca0192","chunk-4922f1ef":"53e539a4","chunk-4f2bfade":"d8be34e8","chunk-53566aa3":"2184b8ad","chunk-2d21e241":"085ea847","chunk-5ee3e8d0":"ff5aedf1","chunk-61c7ff2a":"8f51daaa","chunk-66bb0f70":"0dfce884","chunk-723b8858":"ac0b5351","chunk-74b9266b":"b0e928bf","chunk-75bcd30c":"21dc15fa","chunk-76ff1337":"dc08e9d1","chunk-93acab12":"803dca6e","chunk-9cc58628":"9646fb7b","chunk-ab7e0cd8":"fb59221d","chunk-b1fc5830":"7af9fd24","chunk-b5a26930":"6ec50a51","chunk-f2e1cc14":"f5843561","dashboard~extra":"0a6f80a9","dashboard":"79adfa2f","extra":"b5c58bd6","pages":"133bcf06","chunk-490e6dd7":"f63b4971"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-01c32d3a":1,"chunk-02c298e0":1,"chunk-7c3af428":1,"chunk-074694fa":1,"chunk-07721f3e":1,"chunk-0aa2bc0f":1,"chunk-0d7b152c":1,"chunk-1633b25b":1,"chunk-18946130":1,"chunk-19fa1fd5":1,"chunk-0bcfae88":1,"chunk-5fec1e49":1,"chunk-1f16a04c":1,"chunk-22cf64ce":1,"chunk-443d0ed2":1,"chunk-5789363a":1,"chunk-00e4166c":1,"chunk-11262fda":1,"chunk-30e9c8ae":1,"chunk-51c84beb":1,"chunk-ffa08bd2":1,"chunk-452384d8":1,"chunk-75bb9704":1,"chunk-750d0c9e":1,"chunk-317182db":1,"chunk-34dd60f0":1,"chunk-35f88b45":1,"chunk-3a383e43":1,"chunk-4922f1ef":1,"chunk-4f2bfade":1,"chunk-53566aa3":1,"chunk-5ee3e8d0":1,"chunk-61c7ff2a":1,"chunk-66bb0f70":1,"chunk-723b8858":1,"chunk-74b9266b":1,"chunk-75bcd30c":1,"chunk-93acab12":1,"chunk-9cc58628":1,"chunk-b1fc5830":1,"chunk-b5a26930":1,"chunk-f2e1cc14":1,"dashboard~extra":1,"dashboard":1,"extra":1,"pages":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"dashboard~extra":"dashboard~extra","dashboard":"dashboard","extra":"extra","pages":"pages"}[chunkId]||chunkId) + "." + {"chunk-01c32d3a":"d02da762","chunk-02c298e0":"6c58aa2a","chunk-2d0cf2f8":"31d6cfe0","chunk-7c3af428":"0e433876","chunk-074694fa":"d02da762","chunk-07721f3e":"7e51d29d","chunk-0aa2bc0f":"e9655486","chunk-0d748c85":"31d6cfe0","chunk-0d7b152c":"d02da762","chunk-1633b25b":"e9655486","chunk-18946130":"dbaaf2e7","chunk-19fa1fd5":"a5bb0035","chunk-0bcfae88":"d040a5df","chunk-5fec1e49":"3dcf2ad4","chunk-1e9224e1":"31d6cfe0","chunk-1f16a04c":"69f3bbc8","chunk-22cf64ce":"3a1c6985","chunk-443d0ed2":"19c6b061","chunk-5789363a":"ae0fffef","chunk-00e4166c":"0c136837","chunk-11262fda":"6a229720","chunk-30e9c8ae":"f6111f96","chunk-51c84beb":"1db3a975","chunk-ffa08bd2":"e4acb23d","chunk-452384d8":"1980cdf3","chunk-75bb9704":"47b1a4f8","chunk-750d0c9e":"d02da762","chunk-285b0c14":"31d6cfe0","chunk-294b265d":"31d6cfe0","chunk-2d0b919a":"31d6cfe0","chunk-2d0bced2":"31d6cfe0","chunk-2d0c9517":"31d6cfe0","chunk-2d0ceb8d":"31d6cfe0","chunk-2d0d6bb3":"31d6cfe0","chunk-2d21af19":"31d6cfe0","chunk-2d21e1a8":"31d6cfe0","chunk-2d225216":"31d6cfe0","chunk-317182db":"2914fec5","chunk-34dd60f0":"a97beb9b","chunk-35f88b45":"3e5476a4","chunk-3a383e43":"d02da762","chunk-4922f1ef":"25813789","chunk-4f2bfade":"e9655486","chunk-53566aa3":"d02da762","chunk-2d21e241":"31d6cfe0","chunk-5ee3e8d0":"dfd7de5e","chunk-61c7ff2a":"34f44c45","chunk-66bb0f70":"d02da762","chunk-723b8858":"62919c72","chunk-74b9266b":"d02da762","chunk-75bcd30c":"0041c187","chunk-76ff1337":"31d6cfe0","chunk-93acab12":"d52a207e","chunk-9cc58628":"fd1ba44c","chunk-ab7e0cd8":"31d6cfe0","chunk-b1fc5830":"e9655486","chunk-b5a26930":"d02da762","chunk-f2e1cc14":"d02da762","dashboard~extra":"a80b77e4","dashboard":"1308be49","extra":"39a1f6c5","pages":"d5a9b1a2","chunk-490e6dd7":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
